import ActionRow from './ActionRow'

function ActionButtonRow({ Icon, label, trailingIcon, onClick, compact = false }) {
  return <ActionRow Icon={Icon} label={label} trailingIcon={trailingIcon} onClick={onClick} compact={compact} />
}

export default ActionButtonRow
